import { api } from '../../';
import {
  ParticipationsData,
  ParticipationRequest,
  ParticipationResponse,
  DocumentType,
  ValidatePhoneResponse,
  Campaign,
} from './types';

export const customerSupportApi = api.enhanceEndpoints({ addTagTypes: ['CustomerSupport'] }).injectEndpoints({
  endpoints: build => ({
    getParticipationsList: build.query<ParticipationsData, { campaignId: number; queryString?: string }>({
      query: ({ campaignId, queryString }) => ({
        url: `v1/promotions/admin/major-draw/participants?campaignId=${campaignId}${queryString ? `&${queryString}` : ''}`,
        method: 'GET',
      }),
    }),
    validateParticipationCode: build.query<void, { campaignId: string, code: string }>({
      query: ({campaignId, code}) => ({
        url: `v1/promotions/admin/major-draw/validate/code?campaignId=${campaignId}&code=${encodeURIComponent(code)}`,
        method: 'GET',
      }),
    }),
    saveParticipation: build.mutation<ParticipationResponse, ParticipationRequest>({
      query: body => ({
        url: `v1/promotions/admin/major-draw/register`,
        method: 'POST',
        body,
      }),
    }),
    validatePhone: build.query<ValidatePhoneResponse, { campaignId: string; phone: string }>({
      query: ({ campaignId, phone }) => ({
        url: `v1/promotions/admin/major-draw/validate/phone?campaignId=${campaignId}&phone=${encodeURIComponent(phone)}`,
        method: 'GET',
      }),
    }),
    getActiveCampaigns: build.query<Campaign[], void>({
      query: () => ({
        url: `v1/promotions/admin/campaigns/active`,
        method: 'GET',
      }),
    }),
    getDocumentTypes: build.query<DocumentType[], { countryCode: string }>({
      query: ({ countryCode }) => ({
        url: `v1/promotions/admin/document-types?countryCode=${countryCode}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyGetParticipationsListQuery,
  useLazyValidateParticipationCodeQuery,
  useLazyValidatePhoneQuery,
  useSaveParticipationMutation,
  useLazyGetActiveCampaignsQuery,
  useLazyGetDocumentTypesQuery,
} = customerSupportApi;
